import CompanyOfficialBlock from './company-official';
import { CorporateApplicationStepFourTypes } from './types';

const NewApplicationCorporateInfoStepFour = ({
  mainRepresentativeApplications,
  companyOfficial,
  applicationId,
  setValue,
  status,
  isEditable,
  errors,
  applicationStatus,
  initialFields,
  fields,
  questionnarieFields,
  onSubmit: onApplicationSubmit,
  setDefaultFormValues,
  defaultFormValues: defaultApplicationFormValues,
  defaultQuestionnarieFormValues,
  applicationScheme,
  getApplicationChat,
  onSaveAccountsCurrencies,
  onSaveAccountsFlows,
  onSaveExpectedFundsOrigins,
}: CorporateApplicationStepFourTypes) => (
  <CompanyOfficialBlock
    applications={mainRepresentativeApplications}
    applicationId={applicationId}
    fields={fields}
    initialFields={initialFields}
    onApplicationSubmit={onApplicationSubmit}
    questionnarieFields={questionnarieFields}
    defaultQuestionnarieFormValues={defaultQuestionnarieFormValues}
    applicationScheme={applicationScheme}
    onSaveAccountsCurrencies={onSaveAccountsCurrencies}
    onSaveAccountsFlows={onSaveAccountsFlows}
    onSaveExpectedFundsOrigins={onSaveExpectedFundsOrigins}
    applicationsList={companyOfficial}
    setValue={setValue}
    setDefaultFormValues={setDefaultFormValues}
    defaultApplicationFormValues={defaultApplicationFormValues}
    zIndex={18}
    applicationStatus={applicationStatus}
    getApplicationChat={getApplicationChat}
    isEditable={isEditable}
    status={status}
    errors={errors}
  />
);

export default NewApplicationCorporateInfoStepFour;
